import { CLICK, component, demoFile, extend, extendWithVariants, feature, INPUT, POPUP, story, variant } from "system/demo";
import { HumanModerationModal, ModerationNote } from 'feature/moderation/human-reviews-everything';
import { ModerationModal } from 'feature/moderation/ai-premoderator';
import React, { useState } from "react";
import { CTAButton } from "component/button";
import { Comment, Composer } from "component/comment";

demoFile('feature/moderation/human-reviews-everything', {
    designUrl: 'https://www.figma.com/design/kf97PnjRjvYiMosLYnItoF/Graceful-Fallbacks---Testing?node-id=63-200&node-type=canvas&m=dev'
})

component('Moderation Note', ModerationNote);

function ModalButton({modal}) {
    const [open, setOpen] = useState(false);
    return <>
        <CTAButton onPress={() => setOpen(true)} text='Open Modal'/>
        {open && React.createElement(modal, {onClose: () => setOpen(false)})}
    </>
}

const HumanModerationModalDemo = () => <ModalButton modal={HumanModerationModal} />;
component('HumanModerationModal', HumanModerationModalDemo, {}, [
    story('Open Modal', [
        CLICK('Open Modal'),
    ]),
    story('Open and Close Modal', [
        CLICK('Open Modal'),
        POPUP(CLICK('close-modal'))
    ])
])

extend('Composer', 'Human Moderation', Composer, {
    structureKey: 'question',
    features: ['human_premoderation', 'hide_rejected'],
    args: {goBackAfterPost: true, commentKey: '1'},
    state: {
        serverCall: {
            moderation: {
                sendToReview: async () => 'x1'
            },
            derivedviews: {
                runTriggers: async () => {}
            }
        }
    }
}, [
    story('Post Comment', [
        INPUT('comment-edit', 'Elvis lives'),
        CLICK('Post'),
        POPUP(CLICK('close-modal'))
    ]),
    story('Community Guidelinelines', [
        CLICK('Community Guidelines'),
        POPUP(CLICK('close-modal')),
    ])
])

extendWithVariants('Comment', 'In Review', Comment, {}, [
    variant('In Review', {
        args: {commentKey: 'a'},
        state: {
            collections: {comment: [
                {key: 'a', from: 'a', text: 'Is Godzilla Good?', inReview: true}
            ]}
        },
        structureKey: 'question',
        features: ['hide_rejected']
    })
])

feature('human_premoderation', {
    structureKey: 'question',
    state: {
        globals: {
            name: 'Is Godzilla Good?',
            questionAuthor: 'a',
            questionTime: Date.now(),
        }
    }
})


